import React from "react"
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"

import { BACKEND_APIS } from "@constants"
import { slaveId } from "@signals/user"
import { getSubmit } from "@ui-seeker/utils"
import { useSignal } from '@preact/signals-react'
import { dsColorNew } from "@palette"


export default function SlavesAutocomplete() {

	const slave = useSignal(null)
	return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
		sx={{
			width: "200px",
			"& .MuiInputBase-root": {
				backgroundColor: dsColorNew.filterInputBg,
			},
			"& .MuiOutlinedInput-root": {
				"& fieldset": {
					borderColor: dsColorNew.grayBorder,
				},
				"&:hover fieldset": {
					borderColor: dsColorNew.webBlue500,
				},
				"&.Mui-focused fieldset": {
					borderColor: dsColorNew.webBlue500,
				}
			},
			"& .MuiInputLabel-root": {
				color: dsColorNew.textMuted,
			},
			"& .Mui-focused .MuiInputLabel-root": {
				color: dsColorNew.webBlue500,
			},
			"& .MuiFormHelperText-root": {
				color: dsColorNew.textMuted,
			}
		}}
		filters={{
			selected: slave.value
		}}
		useLoading
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/report/options/slaves`}
		onFinishAjax={options => {
			const selectedOption = options.filter(({selected}) => selected)[0]
			if(selectedOption) slave.value = selectedOption.value
		}}
		placeholder="Users"
		value={slave.value}
		disabled={false}
		onChange={e => {
			slave.value = e.target.value
			getSubmit(`${BACKEND_APIS.SESSION}/set-slave`, { uidSlave: e.target.value }).then(() => {
				window.location.reload()
			})
		}}
	/>
}